import React from 'react';
export const getTestId = (testId)=>testId !== null && testId !== void 0 ? testId : 'split-button';
export const SPLIT_BUTTON_TOGGLE_BI_NAME = 'toggle_menu';
